import './index.css';
import UIComponent from '../common/UIComponent';
import H5FullScreenBtn from './fullscreenBtn';
import H5PlayBtn from './playBtn';
import H5Progress from './h5progress';
import H5CurrentTime from './h5currentTime';
import H5Duration from './h5duration';
import H5LiveShiftTime from './h5liveshiftTime';
import H5TimeshiftProgress from './h5timeshiftProgress';
import Bubble from './bubble';
import H5MiddlePlayBtn from './h5MiddlePlayBtn';
import SubtitleBtn from '../component/subtitleBtn';
import DefinitionBtn from './definitionBtn';
import VolumeBtn from './volumeBtn/index.js';
import Barrage from './barrage/index.js';
import Landscape from './barrage/landscape.js';
import { debounce } from '../common/Utils';

/**
 * @description 初始化化  H5 移动端播放器相关控制功能
 * @author Sean.shi
 */
export default class H5Component extends UIComponent {
  constructor(elementId, interfaces, markPoints, AiHightlights) {
    super(interfaces);
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.markPoints = markPoints;
    this.AiHightlights = AiHightlights;

    this.init();

    this.UIContainer = document.querySelector(elementId);

    // 控制条5s自动隐藏逻辑
    this.UIContainer.addEventListener(
      'touchmove',
      debounce(() => {
        this.showController();
        clearTimeout(this.hideControllerTimer);
        this.hideControllerTimer = setTimeout(() => {
          this.hideController();
        }, 5000);
      }, 100)
    );

    this.UIContainer.addEventListener('click', e => {
      e.preventDefault();
      if (this.isShowController()) {
        this.hideController();
        clearTimeout(this.hideControllerTimer);
      } else {
        this.showController();
        clearTimeout(this.hideControllerTimer);
        this.hideControllerTimer = setTimeout(() => {
          this.hideController();
        }, 5000);
      }
    });

    this.shadow.addEventListener(
      'click',
      e => {
        e.stopPropagation();
        e.preventDefault();
      },
      false
    );

    this.controllerUp.addEventListener(
      'click',
      e => {
        e.stopPropagation();
        e.preventDefault();
      },
      false
    );
  }

  init() {
    // 创建 h5 控制条容器 shadow > UIMain > ...
    this.shadow = document.createElement('div');
    this.shadow.setAttribute('class', 'vhallPlayerh5-shadow hide');
    this.UIMain = document.createElement('div');
    this.UIMain.setAttribute('class', 'vhallPlayerh5-container');

    this.UIMainRight = document.createElement('div');
    this.UIMainRight.setAttribute('class', 'vhallPlayerh5-container-right');

    this.shadow.appendChild(this.UIMain);
    this.appendChild(this.elementId, this.shadow);

    this.controllerUp = document.createElement('div');
    this.controllerUp.setAttribute('class', 'h5vhallPlayer-container-up');

    // 兼容 恶心的 IOS 层级处理不合理问题 ！！！！
    document.querySelector(`${this.elementId} video`).style.position = 'relative';
    // pull shit code .

    // 是否开启了 时移直播功能
    const isOpenTimeshift = this.interfaces.isLive && this.interfaces.vhallplayer._config.isOpenTimeshift;
    // 直播类型
    const type = this.interfaces.vhallplayer._config.type;
    const istx = this.interfaces.getCdnName() === 'tx';
    // 播放控件
    new H5PlayBtn(this.UIMain, this.interfaces);
    if (this.interfaces.isLive) {
      // 时移直播处理
      if (isOpenTimeshift && type === 'hls' && istx) {
        // 时移直播 - 控制条
        new Bubble(this.shadow, this.interfaces);
        new H5LiveShiftTime(this.UIMain, this.interfaces);
        new H5TimeshiftProgress(this.UIMain, this.interfaces, this.elementId);
      }
    } else {
      // 点播 - 初始化时间进度条
      new H5CurrentTime(this.UIMain, this.interfaces);
      // 点播 - 进度条
      new H5Progress(this.UIMain, this.interfaces, this.elementId, this.markPoints, this.AiHightlights);
      // 点播 - 总时长
      new H5Duration(this.UIMain, this.interfaces);
    }
    this.UIMain.appendChild(this.UIMainRight);
    new Barrage(this.UIMainRight, this.interfaces);
    new Landscape(this.UIMainRight, this.interfaces, this.elementId);
    new SubtitleBtn(this.UIMainRight, this.interfaces, this.elementId, true);

    new VolumeBtn(this.UIMainRight, this.interfaces);

    if (this.theme) {
      this.appendChild(this.elementId, this.controllerUp);
      new DefinitionBtn(this.UIMainRight, this.interfaces, this.elementId);
    }

    // 全屏按钮 - 控件
    new H5FullScreenBtn(this.UIMainRight, this.interfaces);

    // 移动端居中暂停按钮
    new H5MiddlePlayBtn(this.elementId, this.interfaces);
  }

  hideController() {
    this.controllerUp.style.display = 'none';
    this.shadow.style.display = 'none';
  }
  showController() {
    this.controllerUp.style.display = 'block';
    this.shadow.style.display = 'block';
  }
  isShowController() {
    return this.shadow.style.display === 'block';
  }
}
